const ANSWER_CONTROL_SELECTOR = [
    'input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="reset"]):not([disabled])',
    "textarea:not([disabled])",
    "select:not([disabled])",
    '[role="radio"]:not([aria-disabled="true"])',
    '[role="checkbox"]:not([aria-disabled="true"])',
    '[role="combobox"]:not([aria-disabled="true"])',
    '[role="slider"]:not([aria-disabled="true"])',
    'button[data-testid="form-option"]:not([disabled])',
].join(", ");

function isHidden(element: HTMLElement): boolean {
    if (element.hidden || element.getAttribute("aria-hidden") === "true") return true;
    if (element.closest("[hidden], [aria-hidden='true']")) return true;
    const style = window.getComputedStyle(element);
    return style.display === "none" || style.visibility === "hidden";
}

function answerControls(root: ParentNode): HTMLElement[] {
    return Array.from(root.querySelectorAll<HTMLElement>(ANSWER_CONTROL_SELECTOR)).filter(
        (element) => !isHidden(element)
    );
}

/** When a choice already has an answer, focus that option so arrow keys start from it. */
function preferredControl(first: HTMLElement): HTMLElement {
    const group = first.closest('[role="radiogroup"], [data-choice-keyboard], [data-rating-keyboard]');
    if (!group) return first;

    const checked = group.querySelector<HTMLElement>(
        'input[type="radio"]:checked:not([disabled]), [role="radio"][aria-checked="true"], [role="radio"][data-state="checked"]'
    );
    if (checked && !isHidden(checked)) return checked;
    return first;
}

/** Move focus to the first answer control on the current form page. */
export function focusFirstFormInput(root: ParentNode): boolean {
    const first = answerControls(root)[0];
    if (!first) return false;

    const target = preferredControl(first);
    target.focus({ preventScroll: true, focusVisible: true });
    return document.activeElement === target;
}
